<template>
    <div class="ChatHeader">
        <div class="questionBox">
            <div class="questionTips" v-if="questionTips!==''" >
                <q v-html="questionTips" ref="questionTips" :class="[/<[^<>]+>/g.test(questionTips)?'htmlBox':'']"></q>
                <span v-if="questionHeight" class="quote">"</span>
            </div>
        </div>
        <div class="topViewWrapper">
            <div class="children" @click="onBlock">
                <img src="../../assets/img/xiaofeng.png" alt="" class="childImg"/>
            </div>
            <div class="loadingBox clear" v-if="chatLoading">
                <img src="../../assets/img/loading1.gif" alt="" class="loadingImg">
            </div>
            <div class="contentCls" v-else>
                <div class="helloXf">
                    <transition enter-active-class="animated bounceInRight">
                        <div v-show="isViewFade">
<!--                            <div class="tipsTodo" v-html="guideTips">-->
<!--                                {{guideTips?"":pageTips}}-->
<!--                            </div>-->
                            <div class="guideTips" v-html="decodeUnicode(guideTips)">
<!--                                {{guideTips?guideTips:pageTipsTo}}-->
<!--                                {{decodeUnicode(guideTips)}}-->
                            </div>
                        </div>
                    </transition>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import {RandomNumBoth} from "@/utils/utils";
    import {mapState, mapActions, mapMutations} from "vuex";
    export default {
        name: "TopView",
        components: {},
        props: {
            durationNum: {
                type: Number,
                default: 0
            },
            questionTips: {
                type: String,
                default: ""
            },
            guideTips: {
                type: String,
                default: ""
            }
        },
        watch: {
            durationNum(value) {
                // if (value >= 10) {
                //     this.setViewFade(false)
                //     this.setViewFade(true)
                //     this.setTips("不知道说什么？", "戳我试试看...");
                // }
                // if (value < 10) {
                //     this.setViewFade(false)
                //     this.setViewFade(true)
                //     this.setTips("Hello~", "一起来体验吧");
                // }
            },
            questionTips(value){
                this.$nextTick(()=>{
                    if(this.$refs.questionTips){
                        let questionHeight = this.$refs.questionTips.offsetHeight
                        this.questionHeight = questionHeight > parseInt(window.getComputedStyle(this.$refs.questionTips).fontSize) * 1.15 * 4 ? true:false
                    }
                })

            }
        },
        computed: {
            ...mapState(["isViewFade","chatLoading"]),
        },
        data() {
            return {
                isClick: true, ////防止重复点击
                timer: "",
                count: 0,
                pageTips: "",
                pageTipsTo: "",
                isFade: false,
                clickable: false,
                questionHeight: 0
            };

        },
        methods: {
            ...mapMutations([
                "setViewFade"
            ]),
            onAsk() {
                this.$emit("on-ask", "", "");
            },

            setTips(pageTips, pageTipsTo) {
                this.pageTips = pageTips;
                this.pageTipsTo = pageTipsTo;
            },
            onBlock() {
                let that = this;
                if (this.isClick) {
                    this.isClick = false;

                    this.setViewFade(false)
                    // this.setViewFade(true)

                    this.onAsk();

                    setTimeout(function () {
                        that.isClick = true;
                    }, 1000);
                }
            },
            // unicode解码 表情
            decodeUnicode(str) {
                if(str){
                    str = str.replace(/\\/g, "%")
                    return unescape(str)
                } else {
                    return ''
                }

            }
        },
        created() {
                this.setViewFade(true)
                // this.setTips("Hi，我是小封！", "见到你真高兴，您可以试试：");
        },
        mounted() {

        },
        beforeDestroy() {
            clearInterval(this.timer);
        }
    };
</script>
<style lang="less" scoped>
    .ChatHeader {
        padding: .1rem .4rem .4rem .4rem;
        /*min-height: 3.2rem;*/
        .questionBox{
            min-height: 1.2rem;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: end;
            -ms-flex-align: end;
            align-items: flex-end;
            justify-content: flex-end;
            position: relative;
            .questionTips{
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                word-wrap: break-word;
                /*q{*/
                /*    display: inline-flex;*/
                /*}*/
            }
            .htmlBox{
                display: inline-flex;
            }
            .quote{
                position: absolute;
                bottom: 0;
                right: 0;
            }
        }
        .loadingBox {
            padding-top: .4rem;
            margin-left: .2rem;

            .loadingImg {
                width: 3.6rem;
                height: 1.7rem;
            }
        }
        .topViewWrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .pageTips-enter-active {
                transition: all 1s;
            }

            .pageTips-leave-active {
                transition: all .2s;
            }

            .pageTips-leave-to {
                opacity: 0;
            }

            .pageTips-enter {
                transform: translateX(30px);
            }


            .children {

                .childImg {
                    width: 1.5rem;
                    height:2.2rem;
                }

            }

            .contentCls {
                /*position: relative;*/
                padding-left: .4rem;


                .helloXf {

                    font-size: .5rem;
                    color: #fff;

                    .tipsTodo {

                        font-weight: 600;
                        margin: .26rem 0;
                    }

                    .guideTips {
                        margin: .20rem 0;
                        font-size: .40rem;
                        line-height: .62rem;
                        /*img{*/
                        /*    width: 36px;*/
                        /*}*/
                        max-height: 3.8rem;
                        overflow: hidden;
                    }

                }



            }
        }

    }

</style>
